import React from 'react';
import {LeagueEvent} from "../domain/leagueevent/models";
import './ReviewEvent.css';
import {WorkPane, WorkPaneHeader} from "../component-library/WorkPane";
import {AppContainer} from "../domain/AppContainer";
import {useObservableWithInitialValue} from "../hooks/useEntityStore";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSync} from "@fortawesome/free-solid-svg-icons/faSync";
import {EventResultsDisplay} from "./EventResultsDisplay";

interface Props {
    container: AppContainer
    event: LeagueEvent
}

export function ReviewEvent({container, event}: Props): JSX.Element {
    const matches = useObservableWithInitialValue(container.leagueEvent.query.matches$, [])

    function refresh(): void {
        const active = container.leagueEvent.query.getActive()
        container.leagueEvent.service.clear()
        if (active) {
            container.leagueEvent.service.selectLeagueById(active.id)
        }
    }

    return <section className="league-events-body">
        <header className="league-events-body-header">
            <h3>{event.name} ({event.dateString})</h3>
        </header>
        <WorkPane>
            <WorkPaneHeader>Results</WorkPaneHeader>
            <div className="actions review-actions">
                <button className="transparent-border-button" onClick={refresh}>
                    Refresh <FontAwesomeIcon icon={faSync}/>
                </button>
            </div>
            <EventResultsDisplay matches={matches ?? []}/>
        </WorkPane>
    </section>
}
